import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const hasConsent = localStorage.getItem('cookieConsent') === 'accepted';
    
    if (hasConsent) {
      // In a real implementation, you would send this to your analytics backend
      // e.g., axios.post('/api/track/pageview', { path: location.pathname, search: location.search });
      console.log(`[Tracking] User navigated to: ${location.pathname}${location.search}`);
    }
  }, [location]);
};

export default useTracking;
